import * as React from 'react';

import { Link } from 'react-router-dom';

import Base from './Base';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */
import { useSelector } from 'react-redux';
import {clientsHaveIntegration, userIsHDSStaff} from '../../util/hasAccess'; /* eslint-disable-line */

const componentCss = css`


`;

export default React.forwardRef(({ selectedNav, index }, ref) => {

	const clients = useSelector(state => state.CLIENT_LIST)?.items ?? [];
	const auth = useSelector(state => state.auth);

	return <div css={componentCss}>
		<Base ref={ref} index={index} selectedNav={selectedNav}>

			<div className="megamenu">
				<div className="megamenu-columns">
					<div className="primary-columns">
						<h2>Deliveries</h2>
						<div className="columns-2">
							<div className="primary-column">
								<h3>Upload &amp; Manage</h3>
								<Link to="/d/delivery-upload" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-truck-loading" />
											</div>
										</div>
										<div>
											<h4>Import</h4>
											<p className="link-subtext">Upload CSV</p>
										</div>
									</div>
								</Link>
								<Link to="/d/deliveries/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-box" />
											</div>
										</div>
										<div>
											<h4>List Deliveries</h4>
											<p className="link-subtext">List all Deliveries</p>
										</div>
									</div>
								</Link>
								<div className="grid-link-container">
									<Link to="/d/deliveries-geo-issues/all" className="grid-link">Geocode Issues</Link>
									<Link to="/d/deliveries/all/grid-edit" className="grid-link">Grid Edit</Link>
									<Link to="/d/deliveries/all/create" className="grid-link">Create</Link>
								</div>
								{clientsHaveIntegration(clients, 'auspost') && <Link to="/d/boxes/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-box" />
											</div>
										</div>
										<div>
											<h4>List Boxes</h4>
											<p className="link-subtext">List all Boxes</p>
										</div>
									</div>
								</Link>}
								{clientsHaveIntegration(clients, 'auspost') && <Link to="/d/customer-change/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-box" />
											</div>
										</div>
										<div>
											<h4>List Customer Request</h4>
											<p className="link-subtext">List all Customer change requests</p>
										</div>
									</div>
								</Link>}
								{clientsHaveIntegration(clients, 'auspost') && <Link to="/d/auspost-orders/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Auspost Manifests</h4>
											<p className="link-subtext">Create and Print Orders</p>
										</div>
									</div>
								</Link>}
								{clientsHaveIntegration(clients, 'auspost') && <Link to="/d/auspost-data/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Auspost Data Report</h4>
											<p className="link-subtext">View and Download Data</p>
										</div>
									</div>
								</Link>}
								{clientsHaveIntegration(clients, 'auspost') && <Link to="/d/auspost-return/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Auspost Returns</h4>
											<p className="link-subtext">View and Download Data</p>
										</div>
									</div>
								</Link>}
								{clientsHaveIntegration(clients, 'dotwms') && <Link to="/wh/inventory/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Warehouse Inventory</h4>
											<p className="link-subtext">View and Download Data</p>
										</div>
									</div>
								</Link>}
								<Link to="/d/file-uploads/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-file-csv" />
											</div>
										</div>
										<div>
											<h4>View File Uploads</h4>
											<p className="link-subtext">List all file uploads</p>
										</div>
									</div>
								</Link>
							</div>

							<div className="primary-column">
								{userIsHDSStaff(auth.user.role) && <div>
									<h3>RDS Deliveries</h3>
									<Link to="/rds/c/all" >
										<div className="megamenu-link">
											<div className="logo-wrapper">
												<div className="megamenu-icon">
													<i className="fa-solid fa-truck-loading" />
												</div>
											</div>
											<div>
												<h4>Clients/Events</h4>
												<p className="link-subtext">Manage RDS Events</p>
											</div>
										</div>
									</Link>
									<Link to="/rds/store/all" >
										<div className="megamenu-link">
											<div className="logo-wrapper">
												<div className="megamenu-icon">
													<i className="fa-solid fa-truck-loading" />
												</div>
											</div>
											<div>
												<h4>Stores</h4>
												<p className="link-subtext">Manage RDS Stores</p>
											</div>
										</div>
									</Link>
									<Link to="/rds/service-provider/all" >
										<div className="megamenu-link">
											<div className="logo-wrapper">
												<div className="megamenu-icon">
													<i className="fa-solid fa-truck-loading" />
												</div>
											</div>
											<div>
												<h4>Service Providers</h4>
												<p className="link-subtext">Manage RDS Service Providers</p>
											</div>
										</div>
									</Link>
								</div>}
								<h3>Purchase Orders</h3>
								<Link to="/po/po-upload" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-truck-loading" />
											</div>
										</div>
										<div>
											<h4>Import</h4>
											<p className="link-subtext">Upload CSV</p>
										</div>
									</div>
								</Link>
								<Link to="/po/purchase-orders" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>List Purchase Orders</h4>
											<p className="link-subtext">List all</p>
										</div>
									</div>
								</Link>
							</div>
						</div>
					</div>
					<div className="secondary-columns">
						<ul>
							<li>
								<Link to="/d/deliveries-export-csv">
									<h4>Export DeTrack CSV</h4>
									<p>Export a CSV for uploading to DeTrack</p>
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</Base>
	</div>

});
